export function getAuthRedirect(value: string | null): string {
    if (!value || !value.startsWith("/") || value.startsWith("//") || /[\\\x00-\x20]/.test(value)) {
        return "/";
    }
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || /^\/(auth|sign-up)(\/|$)/.test(url.pathname)) {
        return "/";
    }
    return url.pathname + url.search + url.hash;
}
